import './Header.scss';
import '@fortawesome/fontawesome-svg-core/styles.css';

import {
    Button,
    LocalizedLink,
} from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Primitives';
import { Link, graphql, useStaticQuery } from 'gatsby';
import { Login, Sidenav } from '.';
import {
    QuickCart,
    QuickCartIcon,
} from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Cart/QuickCart';
import React, { useEffect, useState } from 'react';
import { faBars, faHeart, faUser } from '@fortawesome/free-solid-svg-icons';

import { CSSTransition } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HeaderLogo from '../../images/EnglanderVector.svg';
import SearchBar from '../search/SearchBar';
import SiteLocaleSelectionPopupMenu from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/SiteLocale/SiteLocaleSelectionPopupMenu';
import accountIcon from '@progymedia/sbi-web-englander/src/images/englander-icons/Account-Icon.svg';
import chevronDownIcon from '../../images/englander-icons/Down-Short-Arrow-Icon.svg';
import createAccountIcon from '../../images/englander-icons/Write-Icon.svg';
import iconShopping from '../../images/englander-icons/Cart-Icon.svg';
import loginBackgroundImage from '../../images/backgrounds/background-login.png';
import { useBoutikService } from '@progymedia/gatsby-theme-boutik-ecommerce/src/context/boutikService';
import { useCustomerAccount } from '@progymedia/gatsby-theme-boutik-ecommerce/src/context/customerAccount';
import { useLoginContext } from '@progymedia/gatsby-theme-boutik-ecommerce/src/context/login';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';
import { LoginDrawer } from '@sbi-international/boutik.gatsby.plugin.account';

export default function Header(props: {
    accessories: Map<any, any>;
    venting: Map<any, any>;
}) {
    const { accessories, venting } = props;
    const { isQuickLoginVisible, setQuickLoginVisible } = useLoginContext();
    const { currentLocale, navigateTranslated } = usePageLocalization();
    const [isSidenavOpen, setSidenavOpen] = useState(false);

    const [sidenavClassname, setSidenavClassname] = useState(
        'sidemenu sidenav-closing'
    );
    const [sidemenuClassname, setSidemenuClassname] = useState(
        'sidemenu sidemenu-closing'
    );
    const data = useStaticQuery(graphql`
        query {
            appareils: allProductsJson(
                filter: { code: { eq: "englander_header-appareils" } }
            ) {
                nodes {
                    code
                    title {
                        en_CA
                        en_US
                        fr_CA
                    }
                    images {
                        en_CA
                        en_US
                        fr_CA
                    }
                    fields {
                        ...productsFieldsImagesFragment
                    }
                    attributes {
                        link {
                            values {
                                en_CA
                                en_US
                                fr_CA
                            }
                        }
                    }
                }
            }
            tuyaux: allProductsJson(
                filter: { code: { eq: "englander_header-tuyaux" } }
            ) {
                nodes {
                    code
                    title {
                        en_CA
                        en_US
                        fr_CA
                    }
                    images {
                        en_CA
                        en_US
                        fr_CA
                    }
                    fields {
                        ...productsFieldsImagesFragment
                    }
                    attributes {
                        link {
                            values {
                                en_CA
                                en_US
                                fr_CA
                            }
                        }
                    }
                }
            }
            accessoires: allProductsJson(
                filter: { code: { eq: "englander_header-accessoires" } }
            ) {
                nodes {
                    code
                    title {
                        en_CA
                        en_US
                        fr_CA
                    }
                    images {
                        en_CA
                        en_US
                        fr_CA
                    }
                    fields {
                        ...productsFieldsImagesFragment
                    }
                    attributes {
                        link {
                            values {
                                en_CA
                                en_US
                                fr_CA
                            }
                        }
                    }
                }
            }
            service: allProductsJson(
                filter: { code: { eq: "englander_header-service" } }
            ) {
                nodes {
                    code
                    title {
                        en_CA
                        en_US
                        fr_CA
                    }
                    images {
                        en_CA
                        en_US
                        fr_CA
                    }
                    fields {
                        ...productsFieldsImagesFragment
                    }
                    attributes {
                        link {
                            values {
                                en_CA
                                en_US
                                fr_CA
                            }
                        }
                    }
                }
            }
            alerte: allProductsJson(
                filter: { code: { eq: "englander_banniere-alerte" } }
            ) {
                nodes {
                    code
                    title {
                        en_CA
                        en_US
                        fr_CA
                        markdown {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
            loginMessage: allProductsJson(
                filter: { code: { eq: "englander_connexion" } }
            ) {
                nodes {
                    attributes {
                        texte_3 {
                            values {
                                en_CA
                                en_US
                                fr_CA
                            }
                        }
                    }
                }
            }
        }
    `);
    const isAlertBarDisplayed = data?.alerte?.nodes[0]?.title !== null;
    const { t } = useTranslation('layout');

    useEffect(() => {
        setSidenavClassname(
            isSidenavOpen
                ? 'sidemenu sidenav-window'
                : `sidemenu sidenav-closing`
        );
        const timer1 = setTimeout(
            () =>
                setSidenavClassname(
                    isSidenavOpen
                        ? 'sidemenu sidenav-window'
                        : `sidemenu sidenav-closing`
                ),
            1000
        );

        if (isSidenavOpen) document.body.style.overflow = 'hidden';
        else document.body.style.overflow = 'scroll';

        return () => {
            clearTimeout(timer1);
        };
    }, [isSidenavOpen]);

    useEffect(() => {
        setSidemenuClassname(
            isQuickLoginVisible
                ? 'sidemenu sidemenu-window login-window'
                : `sidemenu sidemenu-closing`
        );
        const timer2 = setTimeout(
            () =>
                setSidemenuClassname(
                    isQuickLoginVisible
                        ? 'sidemenu sidemenu-window login-window'
                        : `sidemenu sidemenu-closing`
                ),
            1000
        );

        if (isQuickLoginVisible) document.body.style.overflow = 'hidden';
        else document.body.style.overflow = 'scroll';

        return () => {
            clearTimeout(timer2);
        };
    }, [isQuickLoginVisible]);

    return (
        <React.Fragment>
            <header className='header'>
                {/* hidden mobile sidenav menu */}
                <div className={sidenavClassname}>
                    <Sidenav
                        action={() => setSidenavOpen(false)}
                        accessories={accessories}
                        ventings={venting}
                    />
                </div>

                <LoginDrawer
                    isOpen={isQuickLoginVisible}
                    onClose={() => setQuickLoginVisible(false)}
                    onCreateAccountClick={
                        () =>
                            setTimeout(
                                () => navigateTranslated('/register/'),
                                300
                            ) // setTimeout pour l'animation
                    }
                    onForgotPasswordClick={
                        () =>
                            setTimeout(
                                () => navigateTranslated('/forgot-password/'),
                                300
                            ) // setTimeout pour l'animation
                    }
                />

                <AlertBanner
                    bannerText={
                        data?.alerte?.nodes[0]?.title?.markdown?.[currentLocale]
                    }
                />
                <TopSection />

                <MainHeader data={data} />
                <Nav />
            </header>
            <QuickCart />
        </React.Fragment>
    );

    function Nav() {
        const { t } = useTranslation('layout');
        const { navigateTranslated, currentLocale } = usePageLocalization();
        const [isHeatersOpen, setIsHeatersOpen] = useState(false);
        const [isVentingOpen, setIsVentingOpen] = useState(false);
        const [isAccessoriesOpen, setIsAccessoriesOpen] = useState(false);
        const [isSupportOpen, setIsSupportOpen] = useState(false);

        return (
            <div className='menu-nav-bg'>
                <div className='menu-nav'>
                    <div
                        className='nav-item'
                        onMouseEnter={() => setIsHeatersOpen(true)}
                        onMouseLeave={() => setIsHeatersOpen(false)}
                        onClick={() => navigateTranslated('/heaters/')}
                    >
                        {t('header.heaters')}
                        <img src={chevronDownIcon} alt='' />

                        {isHeatersOpen && (
                            <div
                                className='nav-submenu'
                                onClick={(event) => event.stopPropagation()}
                            >
                                <div
                                    className='nav-item'
                                    onClick={() => {
                                        navigateTranslated(
                                            '/heaters/wood-stoves/'
                                        );
                                    }}
                                >
                                    {t('header.wood-stoves')}
                                </div>
                               
                                <div
                                    className='nav-item'
                                    onClick={() => {
                                        navigateTranslated(
                                            '/heaters/wood-inserts/'
                                        );
                                    }}
                                >
                                    {t('header.wood-inserts')}
                                </div>
                                <div
                                    className='nav-item'
                                    onClick={() => {
                                        navigateTranslated(
                                            '/heaters/outdoor-fireplaces/'
                                        );
                                    }}
                                >
                                    {t('header.outdoor-fireplaces')}
                                </div>
                                <div
                                    className='nav-item'
                                    onClick={() => {
                                        navigateTranslated(
                                            '/heaters/camp-stoves/'
                                        );
                                    }}
                                >
                                    {t('header.camp-stoves')}
                                </div>
                            </div>
                        )}
                    </div>

                    <div
                        className='nav-item'
                        onMouseEnter={() => setIsVentingOpen(true)}
                        onMouseLeave={() => setIsVentingOpen(false)}
                        onClick={() => navigateTranslated('/venting/')}
                    >
                        {t('header.venting')}{' '}
                        <img src={chevronDownIcon} alt='' />
                        {isVentingOpen && (
                            <div
                                className='nav-submenu'
                                onClick={(event) => event.stopPropagation()}
                            >
                                <div
                                    className='nav-item'
                                    onClick={() => {
                                        navigateTranslated(
                                            '/venting/single-wall-stove-pipe/'
                                        );
                                    }}
                                >
                                    {t('menu-titles.single-wall-pipes')}
                                </div>
                                <div
                                    className='nav-item'
                                    onClick={() => {
                                        navigateTranslated(
                                            '/venting/double-wall-stove-pipe/'
                                        );
                                    }}
                                >
                                    {t('menu-titles.double-wall-pipes')}
                                </div>
                                <div
                                    className='nav-item'
                                    onClick={() => {
                                        navigateTranslated(
                                            '/venting/pellet-vent/'
                                        );
                                    }}
                                >
                                    {t('menu-titles.insert-pellet-stoves')}
                                </div>
                                <div
                                    className='nav-item'
                                    onClick={() => {
                                        navigateTranslated(
                                            '/venting/flex-liner/'
                                        );
                                    }}
                                >
                                    {t('menu-titles.flex-liners')}
                                </div>
                            </div>
                        )}
                    </div>

                    <div
                        className='nav-item'
                        onMouseEnter={() => setIsAccessoriesOpen(true)}
                        onMouseLeave={() => setIsAccessoriesOpen(false)}
                        onClick={() => navigateTranslated('/accessories/')}
                    >
                        {t('header.accessories')}{' '}
                        <img src={chevronDownIcon} alt='' />
                        {isAccessoriesOpen && (
                            <div
                                className='nav-submenu'
                                onClick={(event) => event.stopPropagation()}
                            >
                                {Array.from(accessories)[0][1].map(
                                    (elem: any, index: number) => {
                                        return (
                                            <LocalizedLink
                                                to={`${elem.slug}/`}
                                                key={`${elem.name}_${index}`}
                                                className='nav-item'
                                            >
                                                {elem.label}
                                            </LocalizedLink>
                                        );
                                    }
                                )}
                            </div>
                        )}
                    </div>

                    <LocalizedLink className='nav-item' to='/archives/'>
                        {t('menu-titles.replacement-parts')}
                    </LocalizedLink>

                    <div
                        className='nav-item'
                        onMouseEnter={() => setIsSupportOpen(true)}
                        onMouseLeave={() => setIsSupportOpen(false)}
                    >
                        {t('menu-titles.support-service')}{' '}
                        <img src={chevronDownIcon} alt='' />
                        {isSupportOpen && (
                            <div className='nav-submenu'>
                                <LocalizedLink
                                    to='/where-to-buy/'
                                    className='nav-item'
                                >
                                    {t('menu-titles.where-to-buy')}
                                </LocalizedLink>
                                <LocalizedLink
                                    to='/warranty/wood-stoves/'
                                    className='nav-item'
                                >
                                    {t('menu-titles.warranty')}
                                </LocalizedLink>
                                <LocalizedLink
                                    to='/contact/'
                                    className='nav-item'
                                >
                                    {t('menu-titles.contact')}
                                </LocalizedLink>
                                <LocalizedLink
                                    to='/about/'
                                    className='nav-item'
                                >
                                    {t('menu-titles.about')}
                                </LocalizedLink>
                                <LocalizedLink
                                    to='/gov-incentives/'
                                    className='nav-item'
                                >
                                    {t('menu-titles.gov-incentives')}
                                </LocalizedLink>
                                <LocalizedLink
                                    to='/archives/'
                                    className='nav-item'
                                >
                                    {t('menu-titles.manuals')}
                                </LocalizedLink>
                                <LocalizedLink
                                    to='/videos/'
                                    className='nav-item'
                                >
                                    {t('menu-titles.videos')}
                                </LocalizedLink>
                                <LocalizedLink
                                    to='/faq/wood-stoves/'
                                    className='nav-item'
                                >
                                    {t('menu-titles.faq')}
                                </LocalizedLink>
                                <LocalizedLink
                                    to='/blogArchives/'
                                    className='nav-item'
                                >
                                    {t('menu-titles.blog')}
                                </LocalizedLink>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    function AlertBanner(props: { bannerText: string }) {
        const { bannerText } = props;

        if (bannerText)
            return (
                <div className='alert-banner'>
                    <span
                        className='banner-text'
                        dangerouslySetInnerHTML={{ __html: bannerText }}
                    />
                </div>
            );
        else return null;
    }

    function PageOverlay() {
        return (
            <>
                <CSSTransition
                    in={isQuickLoginVisible}
                    timeout={150}
                    classNames='pageOverlay'
                    unmountOnExit
                >
                    <div
                        className='pageOverlay'
                        onClick={() => {
                            setQuickLoginVisible(false);
                            setSidenavOpen(false);
                        }}
                    ></div>
                </CSSTransition>
            </>
        );
    }

    function TopSection() {
        const { t } = useTranslation('layout');
        const { navigateTranslated } = usePageLocalization();
        const { isAuthenticated } = useBoutikService();
        return (
            <div className='header-top-bg'>
                <div className='header-top'>
                    <QuickCartIcon icon={iconShopping} />
                    <FontAwesomeIcon
                        className='user-icon'
                        icon={faUser}
                        onClick={() => {
                            if (isQuickLoginVisible) {
                                document.body.style.overflow = 'scroll';
                            } else {
                                window.scrollTo(0, 0);
                                document.body.style.overflow = 'hidden';
                            }
                            if (isAuthenticated) {
                                navigateTranslated('/account/my-account/');
                            } else {
                                setQuickLoginVisible(true);
                            }
                        }}
                    />
                    <LocalizedLink to='/' className='header-logo'>
                        <img src={HeaderLogo} alt='Englander Logo' />
                    </LocalizedLink>
                    <SiteLocaleSelectionPopupMenu showCurrency={true} />
                    <LocalizedLink
                        className='page-link'
                        label={t('header.contact-us')}
                        to={`/contact/`}
                    />
                    <LocalizedLink
                        className='page-link'
                        label={t('header.find-retailer')}
                        to={`/where-to-buy/`}
                    />
                    <FontAwesomeIcon
                        onClick={() => setSidenavOpen(!isSidenavOpen)}
                        className='hamburger-menu'
                        icon={faBars}
                    />
                </div>
            </div>
        );
    }

    function MainHeader(props: { data: any }) {
        const { data } = props;
        const { t } = useTranslation('layout');
        const { navigateTranslated, currentLocale } = usePageLocalization();
        const { isAuthenticated } = useBoutikService();
        const { currentUser } = useCustomerAccount();
        const [navMenuOpen, setNavMenuOpen] = useState('none');

        return (
            <div
                className='header-navmenu'
                onMouseLeave={() => setNavMenuOpen('none')}
            >
                <div className='header-nav'>
                    <LocalizedLink to='/' className='header-logo'>
                        <img src={HeaderLogo} alt='Englander Logo' />
                    </LocalizedLink>

                    <SearchBar />

                    <div className='header-action'>
                        <img src={accountIcon} alt='' />
                        <span
                            className='account-title'
                            onClick={() => {
                                if (isQuickLoginVisible) {
                                    document.body.style.overflow = 'scroll';
                                } else {
                                    window.scrollTo(0, 0);
                                    document.body.style.overflow = 'hidden';
                                }
                                if (isAuthenticated) {
                                    navigateTranslated('/account/my-account/');
                                } else {
                                    setQuickLoginVisible(true);
                                }
                            }}
                        >
                            {isAuthenticated
                                ? currentUser?.firstname
                                : t('header.my-account')}
                        </span>
                    </div>
                    {/*  <div className='header-action'>
                        <FontAwesomeIcon icon={faHeart} />
                    </div> */}
                    <div className='header-action cart'>
                        <QuickCartIcon icon={iconShopping} />
                    </div>
                </div>
            </div>
        );
    }
}
